import styled from 'styled-components';
import { Card, Grid } from '../../../ui-toolkit';
import React from 'react';
import { AddNewComment } from './AddNewComment';

export const ScrollContainerWrapper: React.FC<{
  onSubmit: (newComment: string) => void;
  children?: React.ReactNode;
}> = ({ children, onSubmit }) => {
  return (
    <ScrollContainer>
      <ScrollCard title={'Comments'}>
        <Grid>
          {children}
          <AddNewComment onSubmit={onSubmit} />
        </Grid>
      </ScrollCard>
    </ScrollContainer>
  );
};

const ScrollContainer = styled.div`
  height: 100%;
  position: relative;
`;
const ScrollCard = styled(Card)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow-y: auto;
`;
